import { useEffect } from 'react';
import { useAuth0Wrapper } from './auth0';
import { useRecentlyViewedProducts } from './useRecentlyViewedProducts';
import { useSelector } from 'react-redux';

/* useRVPUpdate - hook which adds a product to recently viewed products list for anonymous and logged in users.
 * Intended to be invoked on PDP where productId extracted from url params */
export const useRVPUpdate = (productId) => {
  const { isAuthenticated, isLoading } = useAuth0Wrapper();
  const { saveRecentlyViewedProductToProfile, saveRecentlyViewedProductAnonymously } = useRecentlyViewedProducts();
  const profile = useSelector(({ profile }) => profile);

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      saveRecentlyViewedProductAnonymously(productId);
    } else {
      saveRecentlyViewedProductToProfile(productId, profile);
    }
  }, [isAuthenticated, isLoading, productId, profile?.recentlyViewedProducts?.length]);
};
